module.exports = __webpack_public_path__ + "media/images/products/cards/fundos_de_investimento-64f72fb4254d0290b812f3b61ae53003.png";